import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import DragAndDropList from 'hb-builder/components/common/DragAndDropList';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';

import AddImageButton from './AddImageButton';
import ContentItem from './ContentItem';

const Content = ({ item, onChange }: ComponentSettingsTab) => {
  const [sliderItem] = item.children || [];

  return (
    <ContentWrapper>
      {/* @ts-expect-error not typed */}
      <DragAndDropList
        childrenComponent={ContentItem}
        componentName="Image"
        item={sliderItem}
        listButton={<AddImageButton item={item} />}
        onChange={onChange}
        selectedChildParentItem={sliderItem}
      />
    </ContentWrapper>
  );
};

export default Content;

const ContentWrapper = styled(Box).attrs(() => ({
  flexDirection: 'column',
  width: '100%',
}))``;
